module.exports = "/fonts/vendor/boxicons/boxicons.eot?4002d1c83d8dd40df85708c5601993e4";